module.exports = __webpack_public_path__ + "img/icon_controltemp.53f6483b.svg";